
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/market-sectors/[marketSector]",
      function () {
        return require("private-next-pages/market-sectors/[marketSector].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/market-sectors/[marketSector]"])
      });
    }
  